import fetch from 'fetch';
import { isTesting } from '@embroider/macros';
export function makeApiRequest({
  url,
  body
}) {
  if (typeof window.navigator.sendBeacon === 'function' && !isTesting()) {
    requestWithSendBeacon({
      url,
      body
    });
  } else {
    requestWithFetch({
      url,
      body
    });
  }
}
function requestWithSendBeacon({
  url,
  body
}) {
  let blob = new Blob([body], {
    type: 'application/json'
  });
  navigator.sendBeacon(url, blob);
}
function requestWithFetch({
  url,
  body
}) {
  fetch(url, {
    method: 'POST',
    body,
    headers: {
      'content-type': 'application/json'
    }
  });
}